import React from 'react';
import { Avatar, Card, Icon, PopConfirm, Popover } from './index';
import { moment } from '../utils/moment';
import { Col, Row } from 'antd';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  archiveProject,
  deleteProject,
  unarchiveProject,
} from '../pages/Dashboard/actions';
import { getProjectLogo } from '../utils/helpers';

const ProjectCard = ({ data }) => {
  const {
    name,
    image,
    members,
    createdAt,
    _id,
    color,
    history,
    activityCount,
  } = data;
  const dispatch = useDispatch();

  const formatTime = (time) => {
    const givenTime = time;

    // Get the current timestamp and today's date
    const currentTime = moment();
    const today = moment().startOf('day');

    // Check if the given time is in today's date
    if (moment(givenTime).isBetween(today, currentTime)) {
      // Show the time in HH:MM AM/PM format
      return moment(givenTime).format('h:mm A');
    } else {
      // Get yesterday's date
      const yesterday = moment().subtract(1, 'days').startOf('day');

      // Check if the given time is in yesterday's date
      if (moment(givenTime).isBetween(yesterday, today)) {
        // Show "Yesterday"
        return 'Yesterday';
      } else {
        // Show the date in DD/MM/YYYY format
        return moment(givenTime).format('DD/MM/YYYY');
      }
    }
  };
  const unarchiveLabel = React.useMemo(
    () => (
      <PopConfirm
        title="Are you sure to unarchive this project?"
        onConfirm={() => dispatch(unarchiveProject(_id))}
        content={<div>Unarchive</div>}
      />
    ),
    []
  );
  const archiveLabel = React.useMemo(
    () => (
      <PopConfirm
        title="Are you sure to archive this project?"
        onConfirm={() => dispatch(archiveProject(_id))}
        content={<div>Archive</div>}
      />
    ),
    []
  );
  const deleteLabel = React.useMemo(
    () => (
      <PopConfirm
        title="Are you sure to delete this project?"
        onConfirm={() => dispatch(deleteProject(_id))}
        content={<div>Delete</div>}
      />
    ),
    [_id]
  );

  const ThumbnailComponent = ({ image, name }) => {
    if (image) {
      return <img src={getProjectLogo(image)} alt="" className="img" />;
    } else {
      return (
        <>
          <span
            style={{
              color: color,
              fontSize: '30px',
              fontWeight: 'bold',
            }}
          >
            {name.slice(0, 1)}
          </span>
        </>
      );
    }
  };

  return (
    <Card className="projectCard">
      <div className="top">
        {/* <div className="dates"> */}
        <Row
          justify={'space-between'}
          gutter={2}
          align={'middle'}
          wrap={true}
          style={{
            background: '',
            width: '100%',
            fontSize: '10px',
          }}
          md={24}
        >
          <Col xs={6} style={{ fontWeight: 'bold' }}>
            {history.length > 0
              ? formatTime(history[history.length - 1]?.createdAt)
              : formatTime(createdAt)}
          </Col>
          <Col
            xs={13}
            style={{
              overflow: 'clip',
              display: 'flex',
              justifyContent: 'flex-start',
              fontSize: '10px',
              color: 'grey',
            }}
          >
            {history.length > 1
              ? history[history.length - 1]?.title.slice(0, 30) + '...'
              : 'Journey created'}
          </Col>
          <Col xs={3} style={{ fontWeight: 'bold', fontSize: '12px' }}>
            {/* <span
                     style={{
                        // display: totalCommentsCount > 0 ? "" : "none",
                        color: totalCommentsCount > 0 ? "green" : "grey",
                     }}
                  >
                     @
                  </span> */}
            <span
              style={{
                background: activityCount > 0 ? 'green' : 'grey',
                display: activityCount > 0 ? '' : 'none',
                color: '#fff',
                paddingLeft: '5px',
                paddingRight: '5px',
                paddingTop: '1px',
                paddingBottom: '1px',
                borderRadius: '50px',
              }}
            >
              {activityCount}
            </span>
          </Col>
          <Col xs={2}>
            <div className="menuLink">
              <Popover
                button={
                  <div className="menu-icon">
                    <div>
                      <Icon name="dots-horizontal" />
                    </div>
                  </div>
                }
                menu={[
                  data.archived
                    ? { value: 1, label: unarchiveLabel }
                    : { value: 1, label: archiveLabel },
                  { value: 2, label: deleteLabel },
                ]}
              />
            </div>
          </Col>
        </Row>
        {/* </div> */}
      </div>
      <Link
        to={'/project/' + _id + '/board'}
        className="projectImg"
        style={{ backgroundColor: 'white', border: `3px solid ${color}` }}
      >
        <ThumbnailComponent
          image={image}
          name={name ? name : ''}
          color={color}
        />
      </Link>
      <Link className="nameContainer" to={'/project/' + _id + '/board'}>
        <div className="name">{name}</div>
      </Link>
      <Row className="members">
        {members.slice(0, 3).map(({ user }) => (
          <div key={user._id} className="member">
            <Avatar src={user.avatar} name={user.firstName?.toUpperCase()} />
          </div>
        ))}
        {members.length - 3 > 0 ? (
          <div className="memberSize">+{members.length - 3}</div>
        ) : null}
      </Row>
    </Card>
  );
};

export default ProjectCard;
